import { Location, getDistanceBetween } from './Location';
import { State } from './State';
class Nursery {
  id: number;
  user_id: number;
  contact_name: string;
  name: string;
  address: string;
  address2: string;
  city: string;
  state_id: number;
  postal_code: string;
  lat_lng: Location;
  phone: number;
  website: string;
  email: string;
  hours: string;
  description: string;
  slug: string;
  show_profile: number;
  status_id: number;
  entered_by: number;
  modified_by: number;
  active: number;
  created_at: string;
  updated_at: string;
  featured_photo_url: string;
  featured_photo_thumb_url: string
  distanceToMe: number;
  state: State;
  is_member: boolean;

  constructor(data: any) {
    this.id = data.id;
    this.user_id = data.user_id;
    this.contact_name = data.contact_name;
    this.name = data.name;
    this.address = data.address;
    this.address2 = data.address2;
    this.city = data.city;
    this.state_id = data.state_id;
    this.postal_code = data.postal_code;
    this.lat_lng = data.lat_lng;
    this.phone = data.phone;
    this.website = data.website;
    this.email = data.email;
    this.hours = data.hours;
    this.description = data.description;
    this.slug = data.slug;
    this.show_profile = data.show_profile;
    this.status_id = data.status_id;
    this.entered_by = data.entered_by;
    this.modified_by = data.modified_by;
    this.active = data.active;
    this.created_at = data.created_at;
    this.updated_at = data.updated_at;
    this.featured_photo_url = data.featured_photo_url;
    this.featured_photo_thumb_url = data.featured_photo_url;
    this.is_member = data.is_member;

    this.distanceToMe = data.distanceToMe;
    this.state = data.state;
    if (data.currentLocation) {
      this.refreshDistanceToMe(data.currentLocation);
    }
  }

  get fullAddress(): string {
    return `${this.address} ${this.city}, ${this.state.abbr}`
  }

  public refreshDistanceToMe(origin: Location): void {
    if (!this.lat_lng.lat || !this.lat_lng.lng) {
      this.distanceToMe = 0;
      return;
    }
    this.distanceToMe = getDistanceBetween({ origin, destination: this.lat_lng });
  }
}

export { Nursery }
